/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { JobGroup } from './JobGroup';
import {
    JobGroupFromJSON,
    JobGroupFromJSONTyped,
    JobGroupToJSON,
    JobGroupToJSONTyped,
} from './JobGroup';
import type { JobType } from './JobType';
import {
    JobTypeFromJSON,
    JobTypeFromJSONTyped,
    JobTypeToJSON,
    JobTypeToJSONTyped,
} from './JobType';

/**
 * 
 * @export
 * @interface GetJobResponse
 */
export interface GetJobResponse {
    /**
     * 
     * @type {string}
     * @memberof GetJobResponse
     */
    jobId: string;
    /**
     * 
     * @type {string}
     * @memberof GetJobResponse
     */
    jobKey: string;
    /**
     * 
     * @type {JobGroup}
     * @memberof GetJobResponse
     */
    jobGroup: JobGroup;
    /**
     * 
     * @type {JobType}
     * @memberof GetJobResponse
     */
    jobType: JobType;
    /**
     * 
     * @type {string}
     * @memberof GetJobResponse
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof GetJobResponse
     */
    cronExpression: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetJobResponse
     */
    isEnabled: boolean;
}



/**
 * Check if a given object implements the GetJobResponse interface.
 */
export function instanceOfGetJobResponse(value: object): value is GetJobResponse {
    if (!('jobId' in value) || value['jobId'] === undefined) return false;
    if (!('jobKey' in value) || value['jobKey'] === undefined) return false;
    if (!('jobGroup' in value) || value['jobGroup'] === undefined) return false;
    if (!('jobType' in value) || value['jobType'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('cronExpression' in value) || value['cronExpression'] === undefined) return false;
    if (!('isEnabled' in value) || value['isEnabled'] === undefined) return false;
    return true;
}

export function GetJobResponseFromJSON(json: any): GetJobResponse {
    return GetJobResponseFromJSONTyped(json, false);
}

export function GetJobResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetJobResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'jobId': json['jobId'],
        'jobKey': json['jobKey'],
        'jobGroup': JobGroupFromJSON(json['jobGroup']),
        'jobType': JobTypeFromJSON(json['jobType']),
        'description': json['description'],
        'cronExpression': json['cronExpression'],
        'isEnabled': json['isEnabled'],
    };
}

export function GetJobResponseToJSON(json: any): GetJobResponse {
    return GetJobResponseToJSONTyped(json, false);
}

export function GetJobResponseToJSONTyped(value?: GetJobResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'jobId': value['jobId'],
        'jobKey': value['jobKey'],
        'jobGroup': JobGroupToJSON(value['jobGroup']),
        'jobType': JobTypeToJSON(value['jobType']),
        'description': value['description'],
        'cronExpression': value['cronExpression'],
        'isEnabled': value['isEnabled'],
    };
}

